<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">
            ข้อมูล Product Keyword
          </h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row v-if="isLoadingData">
          <b-col class="px-4 px-sm-5 py-4 vh-100">
            <img src="/img/loading.svg" class="loading" alt="loading" />
          </b-col>
        </b-row>
        <div>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="Main Keyword"
                placeholder="Main Keyword"
                type="text"
                name="mainKeyword"
                isRequired
                v-model="form.mainKeyword"
                :isValidate="$v.form.mainKeyword.$error"
                :v="$v.form.mainKeyword"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Roboflow Class Name"
                placeholder="roboflowClassName"
                type="text"
                name="lastname"
                v-model="form.roboflowClassName"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <!-- <InputText
                textFloat="Prompt Template Id"
                placeholder="Prompt Template Id"
                type="number"
                name="promptTemplateId"
                isRequired
                v-model="form.promptTemplateId"
                :isValidate="$v.form.promptTemplateId.$error"
                :v="$v.form.promptTemplateId"
              /> -->
              <b-form-group class="mb-0" label="Prompt Template Id">
                <select
                  class="custom-select"
                  v-model="form.promptTemplateId"
                  :id="'promptTemplateId'"
                >
                  <option :value="0">เลือก</option>
                  <option
                    v-for="prompt in listPrompt"
                    :key="prompt.id"
                    :value="prompt.id"
                  >
                    {{ prompt.name }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Fuzzy Score Precent (%)"
                placeholder="Fuzzy Score Precent"
                type="number"
                name="fuzzyScorePrecent"
                isRequired
                v-model="form.fuzzyScorePrecent"
                :isValidate="$v.form.fuzzyScorePrecent.$error"
                :v="$v.form.fuzzyScorePrecent"
              />
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                มีเลข Invoice
                <span class="text-danger">*</span>
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isHaveInvoiceNo"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isHaveInvoiceNo ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col>
              <label class="font-weight-bold main-label">
                สถานะ
                <span class="text-danger">*</span>
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isActive"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isActive ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <!-- <div>
                <b-form-tags v-model="tags" tag-variant="primary">
                  <template #tag="{ tag, removeTag }">
                    {{ tag.value }}
                    <b-button size="sm" @click="removeTag(tag)"
                      >Remove</b-button
                    >
                  </template>
                </b-form-tags>
                <input type="text" v-model="newTag" />
                <button @click="addTag">Add Tag</button>
              </div> -->
              <!-- <div>
                <label for="tags-state-event">Enter tags</label>
                <b-form-tags
                  input-id="tags-state-event"
                  v-model="form.productAlternativeKeywords"
                  :tag-validator="validator"
                  placeholder="Enter Keyword"
                  separator=" "
                  @tag-state="onTagState"
                ></b-form-tags>
              </div> -->

              <!-- <div>
                <b-form-tags
                  v-model="form.productAlternativeKeywords"
                  tag-variant="primary"
                  @input="addTag"
                >
                  <template #tag="{ tag, removeTag }">
                    {{ tag.value }}
                    <b-button size="sm" @click="removeTag(tag)"
                      >Remove</b-button
                    >
                  </template>
                </b-form-tags>
              </div> -->
              <div>
                <!-- no-outer-focus -->
                <!-- <b-form-tags
                  v-model="form.productAlternativeKeywords"
                  class="mb-2"
                > -->
                <!-- tagVariant -->
                <!-- <template v-slot="{  }"> -->
                <b-input-group class="mb-2">
                  <!-- v-bind="inputAttrs"
                        v-on="inputHandlers" -->
                  <b-form-input
                    v-model="newTag"
                    placeholder="New tag - Press enter to add"
                    class="form-control"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addTag()" variant="primary">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
                <div class="d-inline-block" style="font-size: 1.5rem">
                  <b-form-tag
                    v-for="(tag, idx) in form.productAlternativeKeywords"
                    @remove="removeTag(tag, idx)"
                    :key="idx"
                    :title="tag.keyword"
                    class="mr-1"
                  >
                    {{ tag.keyword }}
                  </b-form-tag>
                </div>
                <!-- :variant="tagVariant" -->
                <!-- </template> -->
                <!-- </b-form-tags> -->
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <InputText
                textFloat="prefix InvoiceNo"
                placeholder="prefix InvoiceNo"
                type="text"
                name="prefixInvoiceNo"
                v-model="form.prefixInvoiceNo"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="format InvoiceNo"
                placeholder="format InvoiceNo"
                type="text"
                name="formatInvoiceNo"
                v-model="form.formatInvoiceNo"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="prefix Invoice Date"
                placeholder="prefix Invoice Date"
                type="text"
                name="prefixInvoiceDate"
                v-model="form.prefixInvoiceDate"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="format Invoice Date"
                placeholder="format Invoice Date"
                type="text"
                name="formatInvoiceDate"
                v-model="form.formatInvoiceDate"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="prefix Price Total"
                placeholder="prefix Price Total"
                type="text"
                name="prefixPriceTotal"
                v-model="form.prefixPriceTotal"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Format Price Total"
                placeholder="Format Price Total"
                type="text"
                name="formatPriceTotal"
                v-model="form.formatPriceTotal"
              />
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col md="6">
              <b-button
                :disabled="isDisable"
                @click="cancleHandler"
                class="btn-details-set btn-cancel"
                >CANCEL</b-button
              >
            </b-col>
            <b-col md="6" class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
      <pre>{{ form }}</pre>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);

const alpha = helpers.regex("alpha", /^[\u0E00-\u0E7Fa-zA-Z']*$/);

import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading
  },
  data() {
    return {
      isLoadingData: false,
      modalMessage: "",
      isDisable: false,
      id: this.$route.params.id,
      redirecId: 0,
      form: {
        id: 0,
        mainKeyword: "",
        roboflowClassName: "",
        promptTemplateId: 1,
        isHaveInvoiceNo: 1,
        productAlternativeKeywords: [],
        productIdAlternativeKeywordsDeleted: [],
        isActive: 1,
        fuzzyScorePrecent: 100,

        prefixInvoiceNo: "",
        formatInvoiceNo: "",

        prefixInvoiceDate: "",
        formatInvoiceDate: "",

        prefixPriceTotal: "",
        formatPriceTotal: ""
      },
      newTag: "",
      listPrompt: []
    };
  },
  validations: {
    form: {
      mainKeyword: { required },
      promptTemplateId: { required, alphaNum },
      fuzzyScorePrecent: { required, alphaNum }
      // username: { required },
      // staffId: { required, alphaNum },
      // password: {
      //   required: requiredIf(function () {
      //     return this.id == 0;
      //   }),
      //   password,
      //   minLength: minLength(8)
      // }
    }
  },
  created: async function () {
    this.getDatas();
    this.getListPrompt();
  },
  methods: {
    isAlphabet: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 65 && charCode < 91) {
        return true;
      } else if (charCode > 96 && charCode < 123) {
        return true;
      } else if (charCode > 160 && charCode < 238) {
        return true;
      } else {
        evt.preventDefault();
      }
      // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //   evt.preventDefault();
      // } else {
      //   return true;
      // }
    },
    hadleModalAlertClose() {
      this.$router.push({
        path: `/product-keyword`
      });
    },
    cancleHandler() {
      this.$router.push({ name: "Product Keyword" });
    },
    getDatas: async function () {
      if (this.id !== "0") {
        this.isLoadingData = true;
        await this.axios
          .get(`${this.$baseUrl}/productkeyword/${this.id}`)
          .then(res => {
            if (res.data.result == 1) {
              this.form = { ...this.form, ...res.data.detail };

              this.form.prefixInvoiceNo = this.form.prefixInvoiceNo || "";
              this.form.formatInvoiceNo = this.form.formatInvoiceNo || "";

              this.form.prefixInvoiceDate = this.form.prefixInvoiceDate || "";
              this.form.formatInvoiceDate = this.form.formatInvoiceDate || "";

              this.form.prefixPriceTotal = this.form.prefixPriceTotal || "";
              this.form.formatPriceTotal = this.form.formatPriceTotal || "";

              this.isLoadingData = false;
            }
          });
      } else {
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/productkeyword`, this.form)
        .then(res => {
          if (res.data.result == 1) {
            this.redirecId = res.data.detail.id;
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = res.data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
    addTag() {
      if (this.newTag.trim() !== "") {
        const newTag = {
          id: 0,
          productMainKeywordId: parseInt(this.$route.params.id),
          keyword: this.newTag.trim()
        };
        this.form.productAlternativeKeywords.push(newTag);
        this.newTag = ""; // Clear the input field after adding the tag
      }
    },
    removeTag(tagToRemove, idx) {
      if (tagToRemove.id) {
        this.form.productIdAlternativeKeywordsDeleted.push(tagToRemove.id);
      }
      this.form.productAlternativeKeywords.splice(idx, 1);
    },
    getListPrompt: async function () {
      await this.axios
        .get(
          `${this.$baseUrl}/promptTemplate/list?search=&page=1&perpage=200`,
          this.filter
        )
        .then(res => {
          if (res.data.result == 1) {
            this.listPrompt = res.data.detail.data;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-reset-password {
  background-color: #7160c4;
  color: white;
}
</style>
